import { useEffect, useRef, useState } from "react";
import { IconButton } from "@mui/material";
import { BsInfoCircle } from "react-icons/bs";
import "./MapSearch.css";

export default function MapSearch({ searchOptions, onSelect }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [filteredResults, setFilteredResults] = useState([]);
  const wrapperRef = useRef(null);
  const infoRef = useRef(null);

  // Combine all searchable items with their categories
  const getAllSearchableItems = () => {
    const items = [];
    Object.entries(searchOptions).forEach(([category, values]) => {
      values.forEach((item) => {
        const center = calculateCenter(item.coordinates);
        items.push({
          category,
          value: item.value,
          center, // This will be the calculated center point
        });
      });
    });
    return items;
  };

  // Calculate selection center
  const calculateCenter = (coordinates) => {
    if (!coordinates || coordinates.length === 0) return null;

    const sumLat = coordinates.reduce((sum, coord) => sum + coord.lat, 0);
    const sumLng = coordinates.reduce((sum, coord) => sum + coord.lng, 0);

    // Round to 5 decimal places (approximately 1.1 meters precision)
    return {
      lat: Number((sumLat / coordinates.length).toFixed(5)),
      lng: Number((sumLng / coordinates.length).toFixed(5)),
    };
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle search input change
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.trim() === "") {
      setShowDropdown(false);
      setFilteredResults([]);
      return;
    }

    // Filter results
    const results = getAllSearchableItems().filter((item) =>
      item.value.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredResults(results);
    setShowDropdown(true);
  };

  // Handle selection
  const handleSelect = (item) => {
    setSearchTerm(item.value);
    setShowDropdown(false);
    onSelect(item);
  };

  const handleClear = () => {
    setSearchTerm("");
    setFilteredResults([]);
    setShowDropdown(false);
    onSelect(null); // Notify parent component that selection was cleared
  };

  const openInfoWindow = () => {
    setShowInfoWindow(true);
    console.log("it");
  };

  const closeInfoWindow = () => {
    setShowInfoWindow(false);
    console.log("works");
  };

  return (
    <>
      <div className="search-container with-icon" ref={wrapperRef}>
        <input
          type="text"
          className="search-box"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearch}
        />
        {searchTerm && (
          <IconButton
            variant="ghost"
            className="clear-button"
            onClick={handleClear}
            aria-label="Clear search"
          >
            <span className="text-sm text-gray-400">✕</span>
          </IconButton>
        )}
        {showDropdown && filteredResults.length > 0 && (
          <div>
            {filteredResults.map((item, index) => (
              <div
                key={`${item.category}-${index}`}
                onClick={() => handleSelect(item)}
                className="search-result-item"
              >
                <span className="search-result-value">{item.value}</span>
                <span className="search-result-category">{item.category}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="infoIcon-container">
        <BsInfoCircle
          size={20}
          color="#025269"
          onMouseEnter={openInfoWindow}
          onMouseLeave={closeInfoWindow}
        />
      </div>
      {showInfoWindow && (
        <div className="infoWindow-container">
          <p>
            Search for <b>countries</b>, <b>cities</b>, <b>tenants</b>,{" "}
            <b>sites</b>, or <b>devices</b> by typing on the search bar
          </p>
        </div>
      )}
    </>
  );
}
